"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var EmployeeDirectDepositRuleResource = /** @class */ (function (_super) {
    tslib_1.__extends(EmployeeDirectDepositRuleResource, _super);
    function EmployeeDirectDepositRuleResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmployeeDirectDepositRuleResource.endpoint = '/employeedirectdepositrules';
    EmployeeDirectDepositRuleResource.MODEL_NAME = 'employeedirectdepositrule';
    return EmployeeDirectDepositRuleResource;
}(base_1.default));
exports.default = EmployeeDirectDepositRuleResource;
//# sourceMappingURL=employeedirectdepositrule.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/employeedirectdepositrule.js
// module id = QmjQ
// module chunks = 0